import {CTDJobStatus, CTDJob} from '@crema/services/apis/ctd';

// ---------------------------------------------------------------------------
// Action type string constants
// ---------------------------------------------------------------------------

export const CTD_UPLOAD_START = 'CTD_UPLOAD_START';
export const CTD_UPLOAD_SUCCESS = 'CTD_UPLOAD_SUCCESS';
export const CTD_UPLOAD_FAILURE = 'CTD_UPLOAD_FAILURE';

export const CTD_POLL_UPDATE = 'CTD_POLL_UPDATE';
export const CTD_POLL_STOP = 'CTD_POLL_STOP';

export const CTD_FETCH_HISTORY_START = 'CTD_FETCH_HISTORY_START';
export const CTD_FETCH_HISTORY_SUCCESS = 'CTD_FETCH_HISTORY_SUCCESS';
export const CTD_FETCH_HISTORY_FAILURE = 'CTD_FETCH_HISTORY_FAILURE';

export const CTD_CLEAR_CURRENT_JOB = 'CTD_CLEAR_CURRENT_JOB';

// ---------------------------------------------------------------------------
// Action interfaces
// ---------------------------------------------------------------------------

/** Fired when the upload request is sent (sets isUploading = true). */
export interface CTDUploadStartAction {
  type: typeof CTD_UPLOAD_START;
}

/** Fired when the backend returns the new job_id (upload succeeded). */
export interface CTDUploadSuccessAction {
  type: typeof CTD_UPLOAD_SUCCESS;
  payload: {
    jobId: number;
    status: string;
  };
}

/** Fired when the upload request fails. */
export interface CTDUploadFailureAction {
  type: typeof CTD_UPLOAD_FAILURE;
  error: string;
}

/** Fired on each polling tick with the latest job state from the API. */
export interface CTDPollUpdateAction {
  type: typeof CTD_POLL_UPDATE;
  payload: CTDJobStatus;
}

/** Fired to signal that active polling should cease. */
export interface CTDPollStopAction {
  type: typeof CTD_POLL_STOP;
}

/** Fired when the history-fetch request is sent. */
export interface CTDFetchHistoryStartAction {
  type: typeof CTD_FETCH_HISTORY_START;
}

/** Fired when the history list is successfully retrieved. */
export interface CTDFetchHistorySuccessAction {
  type: typeof CTD_FETCH_HISTORY_SUCCESS;
  payload: CTDJob[];
}

/** Fired when the history-fetch request fails. */
export interface CTDFetchHistoryFailureAction {
  type: typeof CTD_FETCH_HISTORY_FAILURE;
  error: string;
}

/** Fired to reset the current job so the user can start a new submission. */
export interface CTDClearCurrentJobAction {
  type: typeof CTD_CLEAR_CURRENT_JOB;
}

// ---------------------------------------------------------------------------
// Union type consumed by the reducer
// ---------------------------------------------------------------------------

export type CTDActions =
  | CTDUploadStartAction
  | CTDUploadSuccessAction
  | CTDUploadFailureAction
  | CTDPollUpdateAction
  | CTDPollStopAction
  | CTDFetchHistoryStartAction
  | CTDFetchHistorySuccessAction
  | CTDFetchHistoryFailureAction
  | CTDClearCurrentJobAction;
